import {
  ICreateDatasetRequest,
  ICreateDatasetResponse,
  IFetchCustomQueryRequest,
  IGetDatasetResponse,
  IGetFileDataColumnDetailsRequest,
  IGetFileDataColumnDetails,
  IGetWebApiDataColumnDetailsRequest,
  IGetMetaDataColumnsForMySQLRequest,
  IGetMetaDataColumnsForMySQL,
  IGetMetaDataColumnsRequest,
  IGetMetaDataColumns,
  IUpdateDatasetRequest,
  IUpdateDatasetResponse,
  IGetMetaDataTableForMySQLRequest,
  IGetMetaDataTableRequest,
  IGetFileDataTableDetailsRequest,
  IGetFileDataTableDetails,
  IGetMetaDataTableResponse,
  IGetSampleRecordsForCustomQueryRequest,
  IGetSampleRecordsForMySQLRequest,
  IGetSampleRecordsRequest,
  IGetFileDataSampleRecordsRequest,
  IDatasetSchedule,
} from './types/dataset';
import Cookies from 'js-cookie';
import FetchData from '../Components/ServerCall/FetchData';
import Logger from '../Logger';
// import { orderByDependency } from '../Components/Calculations/utils';
import { serverEndPoint } from '../Components/ServerCall/EnvironmentVariables';

export const createDataset = async ({
  connection,
  fname,
  workspaceId,
  isFlatFile,
  tablesSelectedInSidebar,
  relationshipServerObj,
  datasetFilter,
  isExtract,
  jobId,
}: ICreateDatasetRequest) => {
  try {
    const response = await FetchData<ICreateDatasetResponse>({
      requestType: 'withData',
      method: 'POST',
      url: `dataset?workspaceId=${workspaceId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
      data: {
        connectionId: connection,
        datasetName: fname,
        isFlatFileData: isFlatFile,
        isExtract,
        dataSchema: {
          tables: tablesSelectedInSidebar,
          relationships: relationshipServerObj,
          filterPanels: datasetFilter,
        },
        jobId,
      },
    });

    if (!response.status) {
      const apiMessage = response.error || 'Failed to create dataset';
      const errorMessage = apiMessage.startsWith('Error:')
        ? apiMessage.replace('Error:', '')
        : apiMessage;
      return {
        isError: true,
        message: errorMessage,
        data: null,
      };
    }
    return {
      isError: false,
      message: 'Dataset created successfully',
      data: response.data!,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during creation', data: null };
  }
};

export const updateDataset = async ({
  connection,
  datasetId,
  fname,
  workspaceId,
  isFlatFile,
  tablesSelectedInSidebar,
  relationshipServerObj,
  datasetFilter,
  isExtract,
  jobId,
}: IUpdateDatasetRequest) => {
  try {
    const response = await FetchData<IUpdateDatasetResponse>({
      requestType: 'withData',
      method: 'PUT',
      url: `dataset/${datasetId}?workspaceId=${workspaceId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
      data: {
        connectionId: connection,
        datasetName: fname,
        isFlatFileData: isFlatFile,
        isExtract,
        jobId,
        dataSchema: {
          tables: tablesSelectedInSidebar,
          relationships: relationshipServerObj,
          filterPanels: datasetFilter,
        },
      },
    });

    if (!response.status) {
      const apiMessage = response.error || 'Failed to update dataset';
      const errorMessage = apiMessage.startsWith('Error:')
        ? apiMessage.replace('Error:', '')
        : apiMessage;
      return {
        isError: true,
        message: errorMessage,
        data: null,
      };
    }

    return {
      isError: false,
      message: 'Dataset updated successfully',
      data: response.data!,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during update', data: null };
  }
};

// TODO: we may not need this api anymore. Check with prakash
export const fetchDatasets = async () => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: 'dataset',
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'Failed to fetch datasets', data: null };
    }

    return { isError: false, message: 'Fetched datasets successfully', data: response.data };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during dataset fetch', data: null };
  }
};

// TODO: we may not need this api anymore. Check with prakash
export const deleteDataset = async (datasetId: string) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'DELETE',
      url: `dataset/${datasetId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'Failed to delete dataset', data: null };
    }

    return { isError: false, message: 'Dataset deleted successfully', data: response.data };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during deletion', data: null };
  }
};

export const getDataset = async (workspaceId: string, datasetId: string) => {
  try {
    const response = await FetchData<IGetDatasetResponse>({
      requestType: 'noData',
      method: 'GET',
      url: `dataset/${datasetId}?workspaceId=${workspaceId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.status) {
      return { isError: true, message: 'Failed to get dataset', data: null };
    }

    return {
      isError: false,
      message: 'Dataset fetched successfully',
      data: response.data!,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during dataset fetch', data: null };
  }
};

export const fetchCustomQuery = async ({
  workspaceId,
  databaseId,
  queryData,
}: IFetchCustomQueryRequest) => {
  try {
    const url = `metadata-columns-customquery/${databaseId}?workspaceId=${workspaceId}`;
    const response = await FetchData({
      requestType: 'withData',
      method: 'POST',
      url,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
        'Content-Type': 'application/json',
      },
      data: queryData,
    });

    if (!response.status) {
      return { isError: true, message: 'Failed to fetch metadata columns', data: null };
    }

    return {
      isError: false,
      message: 'Metadata columns fetched successfully',
      data: response.data as IGetMetaDataColumns[],
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during metadata fetch', data: null };
  }
};

// // TODO: we may not need this api anymore. Check with prakash
export const getFileData = async () => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: 'file-data',
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'Failed to fetch file data', data: null };
    }

    return {
      isError: false,
      message: 'File data fetched successfully',
      data: response.data, // You can type it if you have an interface
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during file data fetch', data: null };
  }
};

export const getFileDataColumnDetails = async ({
  flatFileId,
  workspaceId,
}: IGetFileDataColumnDetailsRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `file-data-column-details?workspaceId=${workspaceId}&flatfileId=${flatFileId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'POST request failed', data: null };
    }

    return {
      isError: false,
      message: 'POST request successful',
      data: response.data as IGetFileDataColumnDetails[],
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during POST request', data: null };
  }
};

export const getWebApiDataColumnDetails = async ({
  tableId,
  datasetId,
  workspaceId,
}: IGetWebApiDataColumnDetailsRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `file-data-column-details?workspaceId=${workspaceId}&tableId=${tableId}&datasetId=${datasetId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'POST request failed', data: null };
    }

    return {
      isError: false,
      message: 'POST request successful',
      data: response.data as IGetMetaDataColumns[],
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during POST request', data: null };
  }
};

export const getMetaDataColumnsForMySQL = async ({
  databaseId,
  databaseName,
  tableName,
  workspaceId,
}: IGetMetaDataColumnsForMySQLRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `metadata-columns/${databaseId}?database=${databaseName}&table=${tableName}&workspaceId=${workspaceId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'POST request failed', data: null };
    }

    return {
      isError: false,
      message: 'POST request successful',
      data: response.data as IGetMetaDataColumnsForMySQL[],
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during POST request', data: null };
  }
};

export const getMetaDataColumns = async ({
  databaseId,
  databaseName,
  schemaName,
  tableName,
  workspaceId,
}: IGetMetaDataColumnsRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `metadata-columns/${databaseId}?database=${databaseName}&schema=${schemaName}&table=${tableName}&workspaceId=${workspaceId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'POST request failed', data: null };
    }

    return {
      isError: false,
      message: 'POST request successful',
      data: response.data as IGetMetaDataColumns[],
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during POST request', data: null };
  }
};

export const getMetaDataTableForMySQL = async ({
  databaseId,
  databaseName,
  workspaceId,
}: IGetMetaDataTableForMySQLRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: `metadata-tables/${databaseId}?database=${databaseName}&workspaceId=${workspaceId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'GET request failed', data: null };
    }

    return {
      isError: false,
      message: 'GET request successful',
      data: response.data as IGetMetaDataTableResponse,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during GET request', data: null };
  }
};

export const getMetaDataTable = async ({
  databaseId,
  databaseName,
  schemaName,
  workspaceId,
}: IGetMetaDataTableRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: `metadata-tables/${databaseId}?database=${databaseName}&schema=${schemaName}&workspaceId=${workspaceId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'GET request failed', data: null };
    }

    return {
      isError: false,
      message: 'GET request successful',
      data: response.data as IGetMetaDataTableResponse,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during GET request', data: null };
  }
};

export const getFileDataTableDetails = async ({ workspaceId }: IGetFileDataTableDetailsRequest) => {
  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: `file-data?workspaceId=${workspaceId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });

    if (!response.status) {
      return { isError: true, message: 'GET request failed', data: null };
    }

    return {
      isError: false,
      message: 'GET request successful',
      data: response.data as IGetFileDataTableDetails[],
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during GET request', data: null };
  }
};

export const getSampleRecordsForCustomQuery = async ({
  connectionValue,
  num,
  workspaceId,
  data,
}: IGetSampleRecordsForCustomQueryRequest) => {
  try {
    const url = `sample-records-customquery/${connectionValue}/${num}?workspaceId=${workspaceId}`;
    const response = await FetchData({
      requestType: 'withData',
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
      data,
    });

    if (!response.status) {
      return {
        isError: true,
        message: response.data?.message ?? 'Failed to fetch sample records',
        data: null,
        statusCode: response.responseStatusCode,
      };
    }

    return {
      isError: false,
      message: 'Sample records fetched successfully',
      data: response.data,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during sample records fetch', data: null };
  }
};

export const getSampleRecordsForMySQL = async ({
  workspaceId,
  databaseId,
  database,
  table,
}: IGetSampleRecordsForMySQLRequest) => {
  try {
    var response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `sample-records?workspaceId=${workspaceId}&databaseId=${databaseId}&recordCount=100&database=${database}&table=${table}`,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
    });
    if (!response.status) {
      return { isError: true, message: 'Failed to fetch sample records', data: null };
    }
    return {
      isError: false,
      message: 'Sample records fetched successfully',
      data: response.data,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during sample records fetch', data: null };
  }
};

export const getSampleRecords = async ({
  workspaceId,
  databaseId,
  database,
  table,
  schema,
}: IGetSampleRecordsRequest) => {
  try {
    let response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `sample-records?workspaceId=${workspaceId}&databaseId=${databaseId}&recordCount=100&database=${database}&schema=${schema}&table=${table}`,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
    });
    if (!response.status) {
      return { isError: true, message: 'Failed to fetch sample records', data: null };
    }
    return {
      isError: false,
      message: 'Sample records fetched successfully',
      data: response.data,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during sample records fetch', data: null };
  }
};

export const getFileDataSampleRecords = async ({
  flatFileId,
  table,
  workspaceId,
}: IGetFileDataSampleRecordsRequest) => {
  try {
    let response = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: `file-data-sample-records?flatfileId=${flatFileId}&table=${table}&workspaceId=${workspaceId}`,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
    });
    if (!response.status) {
      return { isError: true, message: 'Failed to fetch sample records', data: null };
    }
    return {
      isError: false,
      message: 'Sample records fetched successfully',
      data: response.data,
    };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during sample records fetch', data: null };
  }
};

export const getTableData = async (
  isExtract: boolean,
  dc_uid: string,
  tableObj: any,
  ds_id: string,
  workSpaceId: string,
  allPreviousSavedNonAggregatedCalculations?: any,
  fromPlaybook = false,
) => {
  var database: string = tableObj.database;
  var schema: string = tableObj.schema;
  var table: string = tableObj.table;
  var url: string = '';
  if (isExtract || tableObj.isFlatFile) {
    url = `file-data-sample-records?workspaceId=${workSpaceId}&datasetId=${ds_id}&table=${table}&tableId=${tableObj.id}`;
  } else if (fromPlaybook) {
    url = `sample-records?databaseId=${dc_uid}&workspaceId=${workSpaceId}&datasetId=${ds_id}&table=${table}&recordCount=100&tableId=${tableObj.id}`;
  } else {
    url = `sample-records?workspaceId=${workSpaceId}&databaseId=${dc_uid}&datasetId=${ds_id}&recordCount=100&database=${database}&schema=${schema}&table=${table}&tableId=${tableObj.id}`;
  }

  let res: any;

  if (
    allPreviousSavedNonAggregatedCalculations?.length > 0
    // we have to write a check here for tables. We can't allow this if statement to run on just all the tables
    // TODO: here we have to verify if the table is same as the one where we should render the sample records + saved calculations.
  ) {
    const payload = allPreviousSavedNonAggregatedCalculations.map((calculation: any) => [
      calculation,
    ]);

    // for (const eachCalculation of payload) {
    //   const calculationWhereFlowHasToBeSorted = eachCalculation[0];

    //   const res = orderByDependency(calculationWhereFlowHasToBeSorted);

    //   if (res.error) {
    //     return {
    //       isError: true,
    //       message: res.message as string,
    //       data: null,
    //     };
    //   }

    //   const sortedDependencyStack = res.orderedFlows;

    //   const newSortedFlows: any = {};

    //   for (const sortedDependency of sortedDependencyStack) {
    //     newSortedFlows[sortedDependency] =
    //       calculationWhereFlowHasToBeSorted.flows[sortedDependency];
    //   }

    //   eachCalculation[0].flows = newSortedFlows;
    // }

    res = await FetchData({
      requestType: 'withData',
      method: 'POST',
      url: url,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },

      // TODO: put real data in data here.
      data: payload,
    });
  } else {
    res = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: url,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
    });
  }

  if (!res.status) {
    Logger('info', 'Get Table Data Error', res);
    return {
      isError: true,
      statusCode: res.responseStatusCode,
      message: (res.error ?? 'Eror while fetching Table Data') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Table data fetched successfully',
    data: res.data,
  };
};

export const getTableDataWithCustomQuery = async (
  dc_uid: string,
  table: any,
  workSpaceId: string,
) => {
  var url: string = `sample-records-customquery/${dc_uid}/200?workspaceId=${workSpaceId}`;

  var res: any = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: table.customQuery,
  });

  if (!res.status) {
    Logger('info', 'Get Table Data Error', res);
    return {
      isError: true,
      message: (res.error ?? 'Error while fetching Table Data') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Table data fetched successfully',
    data: res.data,
  };
};

export const getColumnTypeswithCustomQuery = async (
  dc_uid: string,
  table: any,
  workSpaceId: string,
  allPreviousSavedNonAggregatedCalculations?: any,
  fromPlaybook = false,
) => {
  let url: string = `metadata-columns-customquery/${dc_uid}?workspaceId=${workSpaceId}`;
  if (allPreviousSavedNonAggregatedCalculations?.length > 0) {
    /**
     * every calculation info has to be inside an array
     * API requirement:::::
     * [
     *  [{calculationInfo1Properties}],
     * [{calculationInfo2Properties}],
     * ]
     */
    const payload = allPreviousSavedNonAggregatedCalculations.map((calculation: any) => [
      calculation,
    ]);
  }
  var res: any = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: table.customQuery,
  });

  if (!res.status) {
    Logger('info', 'Get Table ColumnTypes Error', res);
    return {
      isError: true,
      message: (res.error ?? 'Error in fetching Columns DataType') as string,
      data: null,
    };
  }
  return {
    isError: false,
    statusCode: res.responseStatusCode,
    message: 'Column type fetched successfully',
    data: res.data,
  };
};

export const getColumnTypes = async (
  isExtarct: boolean,
  dc_uid: string,
  ds_id: string,
  tableObj: any,
  workSpaceId: string,
  allPreviousSavedNonAggregatedCalculations?: any,
  fromPlaybook = false,
) => {
  var database: string = tableObj.database;
  var schema: string = tableObj.schema;
  var table: string = tableObj.table;
  var url: string = '';
  if (isExtarct || tableObj.isFlatFile) {
    url = `file-data-column-details?workspaceId=${workSpaceId}&tableId=${tableObj.id}&datasetId=${ds_id}`;
  } else if (fromPlaybook) {
    url = `metadata-columns/${dc_uid}?workspaceId=${workSpaceId}&tableId=${tableObj.id}&datasetId=${ds_id}`;
  } else {
    url = `metadata-columns/${dc_uid}?workspaceId=${workSpaceId}&database=${database}&schema=${schema}&table=${table}`;
  }

  let res: any;

  if (allPreviousSavedNonAggregatedCalculations?.length > 0) {
    /**
     * every calculation info has to be inside an array
     * API requirement:::::
     * [
     *  [{calculationInfo1Properties}],
     * [{calculationInfo2Properties}],
     * ]
     */
    const payload = allPreviousSavedNonAggregatedCalculations.map((calculation: any) => [
      calculation,
    ]);
    // for (const eachCalculation of payload) {
    //   const calculationWhereFlowHasToBeSorted = eachCalculation[0];

    //   const res = orderByDependency(calculationWhereFlowHasToBeSorted);

    //   if (res.error) {
    //     return {
    //       isError: true,
    //       message: res.message as string,
    //       data: null,
    //     };
    //   }

    //   const sortedDependencyStack = res.orderedFlows;

    //   const newSortedFlows: any = {};

    //   for (const sortedDependency of sortedDependencyStack) {
    //     newSortedFlows[sortedDependency] =
    //       calculationWhereFlowHasToBeSorted.flows[sortedDependency];
    //   }

    //   eachCalculation[0].flows = newSortedFlows;
    // }
    res = await FetchData({
      requestType: 'withData',
      method: 'POST',
      url: url,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
      data: payload,
    });
  } else {
    res = await FetchData({
      requestType: 'noData',
      method: 'POST',
      url: url,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
    });
  }

  if (res.status) {
    let finalResult: any = [];
    if (isExtarct || tableObj.isFlatFile) {
      finalResult = res.data.map((el: any) => {
        return {
          columnName: el.fieldName,
          dataType: el.dataType,
        };
      });
    } else {
      finalResult = res.data;
    }
    return {
      isError: false,
      statusCode: res.responseStatusCode,
      message: 'Column type fetched successfully',
      data: finalResult,
    };
  } else {
    Logger('info', 'Get Table ColumnsType Error', res);
    return {
      isError: true,
      statusCode: res.responseStatusCode,
      message: (res.error ?? 'Error in fetching Columns DataType') as string,
      data: null,
    };
  }
};

export const getTables = async (uid: any) => {
  var result: any = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `dataset/${uid}`,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });

  if (!result.status) {
    Logger('error', result.data);
    return {
      isError: true,
      message: (result.error ?? 'Error while fetching Dataset table') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Dataset Table fetched successfully',
    data: result.data,
  };
};

export const getDataSetDetail = async (dsId: string, workspaceId: string) => {
  if (!dsId || !workspaceId)
    return {
      isError: true,
      message: 'Dataset or workspace not found',
      data: null,
    };
  var result: any = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `dataset/${dsId}?workspaceId=${workspaceId}`,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });

  if (!result.status) {
    Logger('error', 'from getDataSetDetail datviewerBottom.tsx', result.error);
    return {
      isError: true,
      message: (result.error ?? 'Error while fetching Dataset detail') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Dataset detail fetched successfully',
    data: result.data,
  };
};

export const getAllDataSets = async () => {
  var result = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `dataset/tree`,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });

  if (!result.status) {
    Logger('error', result.error ?? 'Unknown error');
    return {
      isError: true,
      message: (result.error ?? 'Error fetching datasets') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Datasets fetched successfully',
    data: result.data,
  };
};

export function saveDataset(workspaceId: string, update = false) {
  const url = `${serverEndPoint}dataset?workspaceId=${workspaceId}`;
}
export async function refreshDataset(dsID: string, workspaceId = '') {
  const url = `dataset/refresh/${dsID}?workspaceId=${workspaceId}`;
  const res = await FetchData({
    requestType: 'noData',
    method: 'PUT',
    url,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });
  if (!res.status) {
    Logger('error', res.error ?? 'Unknown error');
    return {
      isError: true,
      message: (res.error ?? 'Error fetching datasets') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Dataset refreshed successfully',
    data: res.data,
  };
}
export const streamEndPoint = (jobId: string) => {
  // datasets/stream?jobId=${jobId}
  return `${serverEndPoint}datasets/stream?jobId=${jobId}`;
};

export const createDatasetSchedule = async (
  datasetId: string,
  workSpaceId: string,
  schedule: IDatasetSchedule,
) => {
  try {
    if (!datasetId || !workSpaceId) {
      return {
        isError: true,
        message: 'Dataset or workspace not found',
        data: null,
      };
    }
    if (!schedule || Object.keys(schedule).length === 0) {
      return { isError: true, message: 'Schedule not provided', data: null };
    }

    const url = `dataset/schedule?datasetId=${datasetId}&workspaceId=${workSpaceId}`;
    const res = await FetchData({
      requestType: 'withData',
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      data: schedule,
    });

    if (!res.status) {
      return {
        isError: true,
        message: 'Failed to create dataset schedule',
        data: null,
      };
    }
    return {
      isError: false,
      message: 'Dataset schedule created successfully',
      data: res.data,
    };
  } catch (error) {
    return {
      isError: true,
      message: 'Unexpected error during creation',
      data: null,
    };
  }
};

export const updateDatasetScheduleStatus = async (
  datasetId: string,
  workSpaceId: string,
  scheduleId: number,
  status: boolean,
) => {
  try {
    if (!datasetId || !workSpaceId) {
      return {
        isError: true,
        message: 'Dataset or workspace not found',
        data: null,
      };
    }
    if (!scheduleId) {
      return {
        isError: true,
        message: 'Schedule id is not provided',
        data: null,
      };
    }
    if (typeof status !== 'boolean') {
      return {
        isError: true,
        message: 'Invalid status provided',
        data: null,
      };
    }

    const url = `dataset/schedule/${scheduleId}?datasetId=${datasetId}&workspaceId=${workSpaceId}&status=${status}`;
    const res = await FetchData({
      requestType: 'noData',
      method: 'PUT',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.status) {
      return {
        isError: true,
        message: 'Failed to update dataset schedule',
        data: null,
      };
    }
    return {
      isError: false,
      message: 'Dataset schedule updated successfully',
      data: res.data,
    };
  } catch (error) {
    return {
      isError: true,
      message: 'Unexpected error during updating dataset schedule',
      data: null,
    };
  }
};

export const getDatasetSchedule = async (datasetId: string, workSpaceId: string) => {
  try {
    if (!datasetId || !workSpaceId)
      return { isError: true, message: 'Dataset or workspace not found', data: null };
    const url = `dataset/schedule?datasetId=${datasetId}&workspaceId=${workSpaceId}`;
    const res = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url,
      headers: {},
    });

    if (!res.status) {
      return { isError: true, message: 'Failed to fetch dataset schedule', data: null };
    }

    return { isError: false, message: 'Dataset Schedule fetched successfully', data: res.data };
  } catch (error) {
    return {
      isError: true,
      message: 'Unexpected error during fetching dataset schedule',
      data: null,
    };
  }
};

export const deleteDatasetSchedule = async (
  datasetId: string,
  workSpaceId: string,
  scheduleId: number,
) => {
  try {
    if (!datasetId || !workSpaceId) {
      return { isError: true, message: 'Dataset or workspace not found', data: null };
    }
    if (!scheduleId) {
      return { isError: true, message: 'Schedule id is not provided', data: null };
    }

    const url = `dataset/schedule/${scheduleId}?datasetId=${datasetId}&workspaceId=${workSpaceId}`;
    const res = await FetchData({
      requestType: 'noData',
      method: 'DELETE',
      url,
      headers: {},
    });

    if (!res.status) {
      return {
        isError: true,
        message: 'Failed to delete schedule',
        data: null,
      };
    }

    return {
      isError: false,
      message: 'Schedule deleted successfully',
      data: res.data,
    };
  } catch (error) {
    return {
      isError: true,
      message: 'Unexpected error during deletion',
      data: null,
    };
  }
};

export const getSchedulePastRuns = async (
  datasetId: string,
  workSpaceId: string,
  scheduleId: number,
) => {
  try {
    if (!(datasetId && workSpaceId && scheduleId)) {
      return {
        isError: true,
        message: 'Missing required parameters',
        data: null,
      };
    }

    const url = `dataset/schedule/${scheduleId}/history?datasetId=${datasetId}&workspaceId=${workSpaceId}`;
    const res = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url,
      headers: {},
    });

    if (!res.status) {
      return {
        isError: true,
        message: 'Failed to fetch schedule past runs',
        data: null,
      };
    }

    return {
      isError: false,
      message: 'Schedule past runs fetched successfully',
      data: res.data,
    };
  } catch (error) {
    return {
      isError: true,
      message: 'Unexpected error during fetching schedule past runs',
      data: null,
    };
  }
};

export const getScheduledNextRuns = async (
  datasetId: string,
  workSpaceId: string,
  scheduleId: number,
) => {
  try {
    if (!(datasetId && workSpaceId && scheduleId)) {
      return {
        isError: true,
        message: 'Missing required parameters',
        data: null,
      };
    }
    const url = `dataset/schedule/${scheduleId}/next-run?datasetId=${datasetId}&workspaceId=${workSpaceId}`;
    const res = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url,
      headers: {},
    });

    if (!res.status) {
      return {
        isError: true,
        message: 'Failed to fetch schedule next runs',
        data: null,
      };
    }

    return {
      isError: false,
      message: 'Schedule next runs fetched successfully',
      data: res.data,
    };
  } catch (error) {
    return {
      isError: true,
      message: 'Unexpected error during fetching schedule next runs',
      data: null,
    };
  }
};
